import Api from "../api";
let uri = "/api/ed/capacitacion/presencial";

export const getCapacitacionesPresenciales = () => {
  return Api.getInstance()
    .executeGetQuery(`${uri}`)
    .then((resp) => resp.data)
    .catch((error) => console.log(error));
};

export const createCapacitacionPresencial = (data) => {
  return Api.getInstance()
    .executeQuery(uri, data)
    .then((res) => res)
    .catch((err) => console.log(err));
};

export const editCapacitacionPresencial = (data) => {
  return Api.getInstance()
    .executeUpdateQuery(uri, data)
    .then((res) => res)
    .catch((err) => console.log(err));
};